<script setup>
import { useRouter } from 'vue-router'
// import { store } from '../store.js'
import { onMounted, ref } from 'vue'
import { useAuthStore, useAssessmentsStore } from '../stores';

const authStore = useAuthStore();
const assessmentsStore = useAssessmentsStore();
const children = ref([])

onMounted(async () => {
    let childrenList = Object.values(authStore.children)
    if (childrenList.length) {
        children.value = childrenList
    } else {
        await authStore.fetchChildren()
        children.value = Object.values(authStore.children)
    }
})

const router = useRouter()
const goToChild = (id) => {
    if (id) {
        router.push(`/account/child/${id}`)
    }
}

const goToReadiness = (childId) => {
    authStore.currentChildId = childId
    router.push('/readiness')
}


const formatDate = (dateString) => {
    const date = new Date(dateString)
    return date.toLocaleDateString()
}
</script>
<template>
    <div>
        <div class="flex flex-col items-center">
            <div>
                <h1 class="mb-4 text-4xl font-extrabold leading-none tracking-tight md:text-5xl lg:text-6xl">Family</h1>
            </div>
            <div role="status" v-if="children.length === 0"
                class="max-w-lg p-4 border border-gray-200 rounded shadow animate-pulse md:p-6 dark:border-gray-700">
                <div class="flex items-center justify-center h-48 mb-4 bg-gray-300 rounded dark:bg-gray-700">
                    <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                        <path
                            d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                        <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                    </svg>
                </div>
                <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-48 mb-4"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5"></div>
                <div class="h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                <div class="flex items-center mt-4 space-x-3">
                    <svg class="w-10 h-10 text-gray-200 dark:text-gray-700" aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path
                            d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                    </svg>
                    <div>
                        <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32 mb-2"></div>
                        <div class="w-48 h-2 bg-gray-200 rounded-full dark:bg-gray-700"></div>
                    </div>
                </div>
                <span class="sr-only">Loading...</span>
            </div>
            <div v-else>
                <div class="grid grid-cols-1 md:grid-cols-3 justify-center content-start">
                    <div role="status"
                        class="max-w-lg p-4 border border-gray-200 text-black rounded shadow  md:p-6 dark:border-gray-700 mb-2 mx-2"
                        v-for="child in children">
                        <div class="w-60">
                            <div
                                class="flex items-center justify-center h-48 mb-4 rounded bg-gray-300 animate-pulse ounded dark:bg-gray-700">
                                <svg class="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                    <path
                                        d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                    <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                                </svg>
                            </div>
                            <div class="flex flex-col w-48 mt-4 items-start w-64">
                                <div class="h-2.5 rounded-full mb-4">{{ `${child.first_name} ${child.last_name[0]}.` }}</div>
                                <!-- <div class="h-2.5 rounded-full mb-8">{{ `${formatDate(child.birthdate)} (${child.months_old} months)` }}</div> -->
                                <div class="h-2.5 rounded-full mb-4">{{ `${child.months_old} months old` }}</div>
                                <div class="h-2.5 rounded-full mb-4">{{ child.days_since_last_assessment ? `${child.days_since_last_assessment} days since last assessment` : 'No assessments yet'  }}</div>
                                <button
                                    class="w-11/12 text-white self-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm py-3 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 mt-4"
                                    type="button" @click.once="goToReadiness(child.id)">Readiness</button>
                                <button
                                    class="w-11/12 text-white self-center bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm py-3 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800 mt-4"
                                    type="button" @click="goToChild(child.id)">Edit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="my-2 w-6/12 md:w-3/12 lg:w-2/12">
                <button
                    class="text-white w-full bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-6 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                    type="button" @click="router.push('/account/child/new')">Add a Child</button>
            </div>
        </div>
    </div>
</template>